






























































































import { Component, Vue } from 'vue-property-decorator';
import { TimeEntryFilter, ReportViewModel, PieChartPoint, TimeEntryFilterTimeFrame } from '@/services/api/nswag/stapiclient_generated';
import { stReportApi } from '@/services/st-api';
import TimeEntryFilterComponent from '@/components/timeentry-filter/TimeEntryFilterComponent.vue';
import SlideIn from '@/components/basic/SlideIn.vue';
import ComparisonCard from '@/views/Report/ComparisonCard.vue';
import {UserStore} from '@/store/user-module';
import {roundToTwo} from '@/utlitities/helper';

Component.registerHooks(['beforeRouteUpdate']);

@Component({
  components: { ComparisonCard, SlideIn, TimeEntryFilterComponent },
})
export default class Reports extends Vue {
  private filter: TimeEntryFilter = TimeEntryFilter.fromJS({
    timeframe: TimeEntryFilterTimeFrame.ThisMonth,
  });
  private loading = true;

  byTagChartOptions = {};
  byCustomerChartOptions = {};
  byProjectChartOptions = {};

  public reportModel: ReportViewModel = ReportViewModel.fromJS({ duration: {}, revenue: {}, billable: {}, customerPieData: {} });

  async applyFilter() {
    await this.loadData();
  }

  async loadData() {
    this.loading = true;
    this.reportModel = await stReportApi.get(this.filter);

    await this.generateByCustomer();
    await this.generateByProject();
    await this.generateByTags();
    this.loading = false;
  }

  get canViewRates() {
    return UserStore.userSettings.CanViewRates && !UserStore.userSettings.noRates;
  }

  get currency(){
    return UserStore.userSettings.currency;
  }

  get hasTagData(){
    return (this.byTagChartOptions as any)?.series?.length
  }

  private getDonutChatOptions(data: PieChartPoint[] | undefined) {
    return {
      chart: {
        type: 'donut'
      },
      labels: data!.map((_) => _.label),
      colors: ['#2980B9', '#5CB85C', '#5BC0DE', '#F0AD4E', '#D9534F', '#428BCA', '#B57C20', '#4AC499', '#A6D9E2', '#C44AB2', '#4AC45C', '#E2AFA6', '#D38678', '#C44A75'],
      tooltip: {
        y: {
          formatter: (value: number) => roundToTwo(value) + ' h'
        }
      },
      legend: {
        formatter: (seriesName: any, opts: any) => {
          return seriesName.length > 35 ? seriesName.substring(0,35) + '...' : seriesName;
        }
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: 'bottom',
            },
          },
        },
      ],
    };
  }

  async generateByTags() {
    this.byTagChartOptions = {
      series: this.reportModel.tagsPieData!.map((_) => _.value),
      chartOptions: this.getDonutChatOptions(this.reportModel.tagsPieData),
    };

    (this.byTagChartOptions as any).chartOptions.labels = this.reportModel.tagsPieData!.map((_) => _.label);
  }

  async generateByCustomer() {
    this.byCustomerChartOptions = {
      series: this.reportModel.customerPieData!.map((_) => _.value),
      chartOptions: this.getDonutChatOptions(this.reportModel.customerPieData),
    };

    (this.byCustomerChartOptions as any).chartOptions.labels = this.reportModel.customerPieData!.map((_) => _.label);
  }

  async generateByProject() {
    this.byProjectChartOptions = {
      series: this.reportModel.projectPieData!.map((_) => _.value),
      chartOptions: this.getDonutChatOptions(this.reportModel.projectPieData),
    };
  }

  get timeRevenueChartOptions() {
    let data = {
      series: [
        {
          name: 'Stunden',
          type: 'bar',
          data: this.reportModel?.timeFrameModel?.map((entry) => entry.hours),
        },
        {
          name: 'Umsatz',
          type: 'line',
          data: this.reportModel?.timeFrameModel?.map((entry) => entry.revenue),
        },
      ],
      chartOptions: {
        chart: {
          height: 350
        },
        colors: ['#2980b9', '#5cb85c'],
        plotOptions: {
          bar: {
            endingShapes: 'round',
            columnWidth: '50px',
          },
        },
        stroke: {
          width: [0, 3],
        },
        dataLabels: {
          enabled: false,
        },
        labels: this.reportModel?.timeFrameModel?.map((entry) => {
          if (this.reportModel?.displayTimeChartDaily) {
            return this.$options.filters?.formatDate(entry.date);
          } else {
            return this.$options.filters?.formatMonth(entry.date);
          }
        }),
        xaxis: {
          type: 'string',
        },
        yaxis: [
          {
            title: {
              text: this.$t('Stunden').toString(),
            },
            labels: {
              formatter: (value: any) => {
                return this.$options.filters?.formatNumber(value);
              },
            },
          },
          {
            title: {
              text: this.$t('Umsatz').toString(),
            },
            opposite: true,
            labels: {
              formatter: (value: any) => {
                return this.$options.filters?.formatNumber(value);
              },
            },
          },
        ],
      },
    };

    if (!this.canViewRates) {
      data.series.splice(1, 1);
      data.chartOptions.yaxis.splice(1, 1);
      data.chartOptions.colors.splice(1, 1);
      (data.chartOptions.chart as any).type = 'bar';
    }

    return data;
  }

}
